import { render, staticRenderFns } from "./AdminFilterSort.vue?vue&type=template&id=8a355cda&scoped=true"
import script from "./AdminFilterSort.vue?vue&type=script&lang=js"
export * from "./AdminFilterSort.vue?vue&type=script&lang=js"
import style0 from "./AdminFilterSort.vue?vue&type=style&index=0&id=8a355cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a355cda",
  null
  
)

export default component.exports